(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uca-cart"]) return;
  try {
    
(() => {
  const cart = document.querySelector('[data-uca-cart]');
  if (!cart) return;
  const quantities = [...cart.querySelectorAll('[data-uca-cart-quantity]')];
  const cartForm = cart.querySelector('.uca-cart-form');
  const updateButton = cart.querySelector('[data-uca-cart-update]');
  const checkoutButton = cart.querySelector('[data-uca-checkout]');
  const updateStatus = cart.querySelector('[data-uca-cart-update-status]');
  const offerForm = cart.querySelector('[data-uca-upgrade-form]');
  const offerButton = cart.querySelector('[data-uca-upgrade-add]');
  const updateNotice = cart.querySelector('[data-uca-upgrade-update]');
  const entrySummary = cart.querySelector('[data-uca-entry-summary]');
  const entryResult = cart.querySelector('[data-uca-entry-result]');
  const entryUpdating = cart.querySelector('[data-uca-entry-updating]');
  const entryDeadline = Number(entrySummary?.dataset.entryCloses || 0) * 1000;
  const entryServerNow = Number(entrySummary?.dataset.serverNow || 0) * 1000;
  const entryStarted = entryDeadline > 0 ? performance.now() : 0;
  let submitting = false;
  let updateTimer;
  let entryTimer;
  const updateEntrySummary = busy => {
    if (entrySummary) entrySummary.setAttribute('aria-busy', String(busy));
    if (entryResult) entryResult.hidden = busy;
    if (entryUpdating) entryUpdating.hidden = !busy;
  };
  const refreshEntryWindow = () => {
    clearTimeout(entryTimer);
    if (!entrySummary || entryDeadline <= 0) return;
    const remaining = entryDeadline - entryServerNow - (performance.now() - entryStarted);
    entrySummary.hidden = remaining <= 0;
    if (remaining > 0) entryTimer = setTimeout(refreshEntryWindow, Math.min(remaining, 2147483647));
  };
  const isDirty = () => quantities.some(input => input.value !== input.dataset.savedQuantity);
  const quantitiesValid = () => quantities.every(input => input.value.trim() !== '' && Number.isSafeInteger(Number(input.value)) && Number(input.value) >= 0);
  const update = () => {
    const dirty = isDirty();
    updateEntrySummary(dirty || submitting);
    if (offerButton) offerButton.disabled = dirty || submitting;
    if (updateNotice) updateNotice.hidden = !dirty;
    if (checkoutButton) checkoutButton.disabled = dirty || submitting;
    if (updateStatus) {
      updateStatus.hidden = !dirty;
      updateStatus.textContent = dirty ? (quantitiesValid() ? updateStatus.dataset.updating : updateStatus.dataset.invalid) : '';
    }
  };
  quantities.forEach(input => input.addEventListener('input', () => {
    clearTimeout(updateTimer);
    update();
    if (!isDirty() || !quantitiesValid() || submitting || !cartForm?.requestSubmit) return;
    updateTimer = setTimeout(() => cartForm.requestSubmit(updateButton), 700);
  }));
  cartForm?.addEventListener('submit', event => {
    clearTimeout(updateTimer);
    if (submitting || !quantitiesValid()) { event.preventDefault(); update(); return; }
    submitting = true;
    updateEntrySummary(true);
    cart.setAttribute('aria-busy', 'true');
    if (offerButton) offerButton.disabled = true;
    if (updateStatus) { updateStatus.hidden = false; updateStatus.textContent = updateStatus.dataset.updating; }
  });
  offerForm?.addEventListener('submit', event => {
    if (submitting || isDirty()) { event.preventDefault(); update(); return; }
    submitting = true;
    update();
  });
  window.addEventListener('pagehide', () => { clearTimeout(updateTimer); clearTimeout(entryTimer); });
  window.addEventListener('pageshow', () => { submitting = false; cart.removeAttribute('aria-busy'); refreshEntryWindow(); update(); });
  refreshEntryWindow();
  update();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uca-shell"]) return;
  try {
    
(() => {
  const store = document.querySelector('[data-uca-store]');
  const panels = [...document.querySelectorAll('[data-uca-panel]')];
  const wallet = document.querySelector('[data-uca-wallet]');
  const navLinks = [...document.querySelectorAll('[data-uca-tab]')];
  const pendingKey = 'uppercut_checkout_started';
  const returnKey = 'uppercut_signin_return';
  const readSession = key => { try { return sessionStorage.getItem(key); } catch { return null; } };
  const writeSession = (key, value) => { try { value === null ? sessionStorage.removeItem(key) : sessionStorage.setItem(key, value); } catch {} };
  let pendingAt = Number(readSession(pendingKey)) || 0;
  let selected = 'home';
  let cards = [];
  let serverAt = 0;
  let measuredAt = 0;
  let expiryTimer;
  let refreshTimer;
  let timeTimer;
  let controller;
  let generation = 0;
  let checking = false;
  let refund = false;
  let personalRecord = null;
  let renderedCard = '';
  const cardMount = wallet?.querySelector('[data-uca-wallet-card]');
  const empty = wallet?.querySelector('[data-uca-wallet-empty]');
  const status = wallet?.querySelector('[data-uca-wallet-status]');
  const help = wallet?.querySelector('[data-uca-wallet-help]');
  const passTools = wallet?.querySelector('[data-uca-pass-tools]');
  const homePass = document.querySelector('[data-uca-home-pass]');
  const counter = document.getElementById('uca-counter');
  const counterMount = counter?.querySelector('[data-uca-counter-card]');
  const timeLabels = [...document.querySelectorAll('[data-uca-time-remaining]')];
  const personalPanels = [...document.querySelectorAll('[data-uca-personal]')];
  const personalFallback = document.querySelector('[data-uca-personal-fallback]');
  const recentPurchases = document.querySelector('[data-uca-recent-purchases]');
  const text = name => wallet?.querySelector('[data-uca-text-' + name + ']')?.textContent || '';
  const now = () => serverAt + performance.now() - measuredAt;
  const isWaiting = () => pendingAt > 0 && Date.now() - pendingAt < 30 * 60 * 1000;
  const visible = () => document.visibilityState !== 'hidden';
  const wantsRefresh = () => wallet && visible() && (['home', 'wallet', 'account'].includes(selected) || counter?.open || isWaiting());
  const displayExpiry = value => new Intl.DateTimeFormat('en-AU', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone: 'Australia/Melbourne', timeZoneName: 'short' }).format(new Date(value));
  const sample = document.querySelector('[data-uca-sample]');
  const sampleSelect = sample?.querySelector('[data-uca-sample-select]');
  const sampleExpiry = Date.now() + 604800000;
  let dialogOpener = null;

  function clearPersonal() {
    personalRecord = null;
    personalPanels.forEach(panel => { panel.hidden = true; });
    document.querySelectorAll('[data-uca-personal-name], [data-uca-personal-initials], [data-uca-personal-message], [data-uca-personal-hint]').forEach(node => { node.textContent = ''; });
    recentPurchases?.replaceChildren();
    if (personalFallback) personalFallback.hidden = false;
  }

  function updatePersonalState() {
    if (!personalRecord || !visible()) return;
    const active = cards[0];
    const calendarDay = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', year: 'numeric', month: 'numeric', day: 'numeric' });
    const state = active ? (calendarDay.format(new Date(active.expires)) === calendarDay.format(new Date(now())) ? 'expiring' : 'active') : personalRecord.dataset.packagesOpen === 'true' ? 'empty' : 'closed';
    const fill = value => value.replace('__PERCENT__', String(active?.percent ?? '')).replace('__EXPIRY__', active ? displayExpiry(active.expires) : '');
    document.querySelectorAll('[data-uca-personal-panel]').forEach(panel => {
      panel.dataset.passState = state;
      const message = panel.querySelector('[data-uca-personal-message]');
      const hint = panel.querySelector('[data-uca-personal-hint]');
      const heading = fill(text('personal-' + state));
      const detail = fill(text('personal-' + state + '-hint'));
      if (message.textContent !== heading) message.textContent = heading;
      if (hint.textContent !== detail) hint.textContent = detail;
    });
  }

  function renderPersonal() {
    if (!personalRecord || !visible()) return clearPersonal();
    const { firstName, name, initials } = personalRecord.dataset;
    document.querySelectorAll('[data-uca-personal-name]').forEach(node => {
      node.textContent = node.dataset.ucaPersonalName === 'home' ? (firstName ? text('personal-welcome').replace('__NAME__', firstName) : text('personal-welcome-generic')) : name;
    });
    document.querySelectorAll('[data-uca-personal-initials]').forEach(node => { node.textContent = initials; });
    recentPurchases?.replaceChildren(personalRecord.content.cloneNode(true));
    personalPanels.forEach(panel => { panel.hidden = false; });
    if (personalFallback) personalFallback.hidden = true;
  }

  function closeDialogs() {
    document.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
  }

  function showSample(show) {
    if (!sample || !wallet) return;
    sample.hidden = !show;
    wallet.hidden = show;
    if (show) {
      sample.querySelector('[data-uca-sample-expiry]').textContent = displayExpiry(sampleExpiry);
      sampleSelect?.focus();
    } else {
      refresh();
      wallet.querySelector('[data-uca-sample-open]')?.focus();
    }
  }

  document.querySelectorAll('[data-uca-sample-open]').forEach(button => { button.hidden = false; });
  document.querySelectorAll('dialog').forEach(dialog => {
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const rect = dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (!document.querySelector('dialog[open]') && dialogOpener?.isConnected) dialogOpener.focus();
    });
  });
  document.addEventListener('change', event => {
    if (event.target !== sampleSelect) return;
    const percent = Number(sampleSelect.value);
    if ([2, 3, 5, 10, 15, 25].includes(percent)) {
      sample.querySelector('[data-uca-sample-percent]').textContent = String(percent);
      const metalCard = sample.querySelector('[data-uca-metal]');
      if (metalCard) metalCard.dataset.ucaMetal = String(percent);
    }
  });

  function clearCard() {
    clearTimeout(expiryTimer);
    clearTimeout(timeTimer);
    cardMount?.replaceChildren();
    renderedCard = '';
    counterMount?.replaceChildren();
    if (counter?.open) counter.close();
    if (passTools) passTools.hidden = true;
    if (homePass) homePass.hidden = true;
    timeLabels.forEach(label => { label.textContent = ''; });
    if (help) help.hidden = true;
    if (empty) empty.hidden = false;
  }

  function updateTime() {
    clearTimeout(timeTimer);
    const active = cards[0];
    if (!active || !visible()) return;
    const remaining = active.expires - now();
    if (remaining <= 0) return renderCard();
    const minutes = Math.floor(remaining / 60000);
    const days = Math.floor(minutes / 1440);
    const hours = Math.floor(minutes % 1440 / 60);
    const unit = (amount, name) => new Intl.NumberFormat('en-AU', { style: 'unit', unit: name, unitDisplay: 'long' }).format(amount);
    let label = days > 0 ? unit(days, 'day') + ', ' + unit(hours, 'hour') : hours > 0 ? unit(hours, 'hour') + ', ' + unit(minutes % 60, 'minute') : unit(minutes, 'minute');
    label = minutes < 1 ? text('minute') : label + ' ' + text('remaining');
    const day = new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', year: 'numeric', month: 'numeric', day: 'numeric' });
    if (day.format(new Date(active.expires)) === day.format(new Date(now()))) label = text('today') + ' · ' + label;
    timeLabels.forEach(element => { element.textContent = label; });
    updatePersonalState();
    timeTimer = setTimeout(updateTime, Math.min(1000, remaining));
  }

  function renderCard() {
    if (!wallet || !visible()) return clearCard();
    clearTimeout(expiryTimer);
    cards = cards.filter(card => card.expires > now());
    cards.sort((a, b) => b.percent - a.percent || b.expires - a.expires);
    const active = cards[0];
    if (active) {
      // Preserve the card during background checks so the entrance and shine
      // play on opening or when a different verified card is displayed.
      const signature = active.id + ':' + active.expires + ':' + active.template.innerHTML;
      if (signature !== renderedCard) {
        const fragment = active.template.content.cloneNode(true);
        fragment.querySelectorAll('[data-uca-expiry]').forEach(el => { el.textContent = displayExpiry(active.expires); });
        const face = fragment.querySelector('.live-pass-card');
        if (counterMount && face) counterMount.replaceChildren(face.cloneNode(true));
        cardMount.replaceChildren(fragment);
        renderedCard = signature;
      }
      empty.hidden = true;
      help.hidden = false;
      if (passTools) passTools.hidden = false;
      if (homePass) {
        homePass.querySelector('[data-uca-home-pass-heading]').textContent = text('active').replace('__PERCENT__', String(active.percent));
        homePass.hidden = false;
      }
      status.textContent = '';
      updateTime();
      expiryTimer = setTimeout(renderCard, Math.max(1, active.expires - now()));
    } else {
      clearCard();
      empty.querySelector('.wallet-placeholder').textContent = text('empty');
      status.textContent = '';
    }
    wallet.querySelector('[data-uca-refund]').hidden = !refund;
    updatePersonalState();
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    if (wantsRefresh()) refreshTimer = setTimeout(refresh, isWaiting() ? 5000 : 60000);
  }

  async function refresh() {
    if (!wantsRefresh() || wallet.dataset.signedIn !== 'true' || checking) return;
    clearTimeout(refreshTimer);
    checking = true;
    const run = ++generation;
    controller = new AbortController();
    const signal = controller.signal;
    status.textContent = text('checking');
    wallet.querySelector('[data-uca-refresh]')?.setAttribute('aria-busy', 'true');
    const root = new URL(wallet.dataset.root, location.origin);
    const initialUrl = new URL(root);
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) initialUrl.searchParams.set('preview_theme_id', preview);
    let cursor = initialUrl;
    const seen = new Set();
    const collected = new Map();
    let hasRefund = false;
    let nextPersonalRecord = null;
    let finalServer = 0;
    let finalMeasured = 0;
    try {
      for (let count = 0; cursor && count < 200; count++) {
        if (cursor.origin !== root.origin || cursor.pathname !== root.pathname) throw new Error('Invalid wallet path');
        cursor.searchParams.set('section_id', 'uca-pass-state');
        cursor.searchParams.set('_uca_verify', String(Date.now()));
        const page = cursor.searchParams.get('page') || '1';
        if (seen.has(page)) throw new Error('Repeated wallet page');
        seen.add(page);
        const started = performance.now();
        const timeout = setTimeout(() => controller?.abort(), 15000);
        let response, html;
        try {
          response = await fetch(cursor, { credentials: 'same-origin', cache: 'no-store', signal, headers: { Accept: 'text/html' } });
          if (!response.ok) throw new Error('Shopify verification unavailable');
          html = await response.text();
        } finally { clearTimeout(timeout); }
        if (run !== generation || !visible()) return;
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const snapshot = documentFragment.querySelector('[data-uca-snapshot]');
        if (!snapshot) throw new Error('No verified wallet');
        if (!snapshot.dataset.customer || snapshot.dataset.customer !== wallet.dataset.customer) {
          cards = [];
          clearCard();
          clearPersonal();
          location.reload();
          return;
        }
        const serverSeconds = Number(snapshot.dataset.serverNow);
        if (!Number.isFinite(serverSeconds) || serverSeconds <= 0) throw new Error('Invalid Shopify clock');
        finalMeasured = performance.now();
        finalServer = serverSeconds * 1000 + (finalMeasured - started);
        hasRefund ||= snapshot.dataset.refund === 'true';
        if (count === 0) nextPersonalRecord = snapshot.querySelector('template[data-uca-personal-records]');
        snapshot.querySelectorAll('template[data-uca-pass]').forEach(template => {
          const percent = Number(template.dataset.percent);
          const expires = Number(template.dataset.expires) * 1000;
          const purchased = Number(template.dataset.purchased) * 1000;
          if (![2, 3, 5, 10, 15, 25].includes(percent) || !Number.isFinite(expires) || !Number.isFinite(purchased) || expires - purchased !== 604800000 || purchased > finalServer || expires <= finalServer || !template.dataset.id) return;
          collected.set(template.dataset.id, { id: template.dataset.id, percent, expires, purchased, template });
        });
        cursor = snapshot.dataset.next ? new URL(snapshot.dataset.next, root) : null;
        if (cursor && preview) cursor.searchParams.set('preview_theme_id', preview);
      }
      if (cursor) throw new Error('Incomplete wallet verification');
      if (run !== generation || !visible()) return;
      serverAt = finalServer;
      measuredAt = finalMeasured;
      refund = hasRefund;
      cards = [...collected.values()];
      personalRecord = nextPersonalRecord;
      renderPersonal();
      const paidAfterCheckout = isWaiting() && cards.some(card => card.purchased >= pendingAt - 60000);
      if (paidAfterCheckout) {
        writeSession(pendingKey, null);
        pendingAt = 0;
        location.hash = 'wallet';
        showTab('wallet', false);
      }
      renderCard();
    } catch (error) {
      if (run !== generation) return;
      cards = [];
      clearCard();
      clearPersonal();
      if (visible()) status.textContent = text('error');
    } finally {
      if (run === generation) {
        checking = false;
        wallet.querySelector('[data-uca-refresh]')?.removeAttribute('aria-busy');
        scheduleRefresh();
      }
    }
  }

  function showTab(tab, moveFocus) {
    if (!store || !panels.some(panel => panel.dataset.ucaPanel === tab)) return;
    closeDialogs();
    if (sample && tab !== 'wallet') { sample.hidden = true; wallet.hidden = false; }
    selected = tab;
    panels.forEach(panel => { panel.hidden = panel.dataset.ucaPanel !== tab; });
    navLinks.forEach(link => {
      if (link.dataset.ucaTab === tab && link.closest('.nav')) link.setAttribute('aria-current', 'page');
      else link.removeAttribute('aria-current');
    });
    if (['wallet', 'home', 'account'].includes(tab)) refresh();
    else scheduleRefresh();
    if (moveFocus) {
      window.scrollTo({ top: 0, behavior: 'instant' });
      document.getElementById('main')?.focus({ preventScroll: true });
    }
  }

  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-uca-dialog]');
    if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      const dialog = document.getElementById(opener.dataset.ucaDialog);
      if (dialog?.showModal) {
        event.preventDefault();
        if (dialog === counter) {
          renderCard();
          if (wallet?.dataset.signedIn !== 'true' || !cards[0] || !counterMount?.firstElementChild) return;
          refresh();
        }
        if (!opener.closest('dialog')) dialogOpener = opener;
        closeDialogs();
        dialog.showModal();
      }
    }
    if (event.target.closest('[data-uca-close]')) closeDialogs();
    if (event.target.closest('[data-uca-sample-open]')) showSample(true);
    if (event.target.closest('[data-uca-sample-close]')) showSample(false);
    const tab = event.target.closest('[data-uca-tab]');
    if (tab && store && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault();
      if (location.hash === '#' + tab.dataset.ucaTab) showTab(tab.dataset.ucaTab, true);
      else location.hash = tab.dataset.ucaTab;
    }
    if (event.target.closest('[data-uca-refresh]')) refresh();
    const signIn = event.target.closest('[data-uca-signin]');
    if (signIn) {
      writeSession(returnKey, location.pathname + location.search + location.hash);
      if (signIn.dataset.ucaReturnProduct) {
        const login = new URL(signIn.href, location.origin);
        login.searchParams.set('return_to', signIn.dataset.ucaReturnProduct);
        signIn.href = login.href;
      }
    }
    if (event.target.closest('[data-uca-signout]')) {
      ++generation;
      controller?.abort();
      clearTimeout(refreshTimer);
      checking = false;
      cards = [];
      clearCard();
      writeSession(pendingKey, null);
      writeSession(returnKey, null);
      clearPersonal();
    }
  });
  document.addEventListener('submit', event => {
    if (event.submitter?.matches('[data-uca-checkout]')) {
      pendingAt = Date.now();
      writeSession(pendingKey, String(pendingAt));
    }
  });
  window.addEventListener('hashchange', () => showTab(location.hash.slice(1), true));
  const suspend = () => {
    ++generation;
    controller?.abort();
    clearTimeout(refreshTimer);
    checking = false;
    cards = [];
    clearCard();
    clearPersonal();
  };
  document.addEventListener('visibilitychange', () => visible() ? refresh() : suspend());
  window.addEventListener('pagehide', suspend);
  window.addEventListener('pageshow', event => { if (event.persisted) refresh(); });
  window.addEventListener('focus', () => { if (wantsRefresh()) refresh(); });
  if (store) {
    store.classList.add('uca-store-ready');
    const preferred = isWaiting() && wallet?.dataset.signedIn === 'true' ? 'wallet' : location.hash.slice(1) || 'home';
    showTab(panels.some(panel => panel.dataset.ucaPanel === preferred) ? preferred : 'home', false);
    if (preferred === 'wallet' && location.hash !== '#wallet') history.replaceState(null, '', location.pathname + location.search + '#wallet');
  }
  const savedReturn = readSession(returnKey);
  if (savedReturn) {
    writeSession(returnKey, null);
    if (savedReturn.startsWith('/') && !savedReturn.startsWith('//')) {
      const target = new URL(savedReturn, location.origin);
      if (target.origin === location.origin && target.pathname === location.pathname && !location.hash && target.hash) {
        location.hash = target.hash;
      }
    }
  }
  // Shopify renders this marker only after a real form response.
  const launchResult = document.querySelector('[data-uca-launch-result]');
  if (launchResult) {
    showTab('home', false);
    launchResult.focus({ preventScroll: true });
    launchResult.scrollIntoView({ block: 'center' });
  }
})();

(() => {
  const schedule = document.querySelector('[data-uca-giveaway]');
  if (!schedule) return;
  const parseDate = value => {
    const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value || '');
    if (!match) return NaN;
    const [, y, m, d, h, min, sec = '00', zone] = match;
    const local = new Date(Date.UTC(+y, +m - 1, +d, +h, +min, +sec));
    if (local.getUTCFullYear() !== +y || local.getUTCMonth() !== +m - 1 || local.getUTCDate() !== +d || +h > 23 || +min > 59 || +sec > 59) return NaN;
    if (zone !== 'Z' && (+zone.slice(1, 3) > 14 || +zone.slice(4) > 59 || (+zone.slice(1, 3) === 14 && +zone.slice(4) !== 0))) return NaN;
    return Date.parse(value);
  };
  const closes = parseDate(schedule.dataset.entryCloses);
  const draw = parseDate(schedule.dataset.drawAt);
  const server = Number(schedule.dataset.serverNow) * 1000;
  if (!Number.isFinite(server) || server <= 0) return;
  const measured = performance.now();
  const now = () => server + performance.now() - measured;
  const label = name => schedule.querySelector('[data-uca-draw-' + name + ']')?.textContent || '';
  const display = value => new Intl.DateTimeFormat('en-AU', { timeZone: 'Australia/Melbourne', weekday: 'short', day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }).format(new Date(value));
  const clock = schedule.querySelector('[data-uca-entry-clock]');
  const digits = schedule.querySelector('[data-uca-entry-digits]');
  const calendar = schedule.querySelector('[data-uca-calendar]');
  const watch = schedule.querySelector('[data-uca-watch]');
  const validClose = Number.isFinite(closes);
  const validDraw = Number.isFinite(draw) && (!validClose || draw >= closes);
  let timer;
  let calendarUrl;
  const escapeText = value => value.replace(/\\/g, '\\\\').replace(/\r\n|\r|\n/g, '\\n').replace(/;/g, '\\;').replace(/,/g, '\\,');
  const utc = value => new Date(value).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}Z$/, 'Z');
  const fold = value => {
    let output = '', line = '', bytes = 0;
    for (const char of value) {
      const length = new TextEncoder().encode(char).length;
      if (bytes + length > 75) { output += line + '\r\n'; line = ' '; bytes = 1; }
      line += char; bytes += length;
    }
    return output + line;
  };
  if (validClose) {
    clock.hidden = false;
    schedule.querySelector('[data-uca-entry-date]').textContent = display(closes);
    ['days', 'hours', 'minutes', 'seconds'].forEach(name => {
      const cell = document.createElement('span');
      const number = document.createElement('b');
      const caption = document.createElement('small');
      number.dataset.ucaClockUnit = name;
      caption.textContent = label(name);
      cell.append(number, caption);
      digits.append(cell);
    });
  }
  if (validDraw) {
    schedule.querySelector('[data-uca-draw-date]').hidden = false;
    schedule.querySelector('[data-uca-draw-time]').textContent = display(draw);
    let watchUrl = '';
    try { const url = new URL(watch?.href); if (url.protocol === 'https:') watchUrl = url.href; } catch {}
    if (watch && watchUrl) watch.hidden = false;
    if (calendar && draw > now()) {
      const title = label('title') + (schedule.dataset.title.trim() ? ' — ' + schedule.dataset.title.trim() : '');
      const description = label('description') + (watchUrl ? '\n' + watchUrl : '');
      const lines = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Uppercut Butchers//Giveaway//EN', 'CALSCALE:GREGORIAN', 'BEGIN:VEVENT', 'UID:uppercut-draw-' + String(draw) + '@theuppercutbutchers.com', 'DTSTAMP:' + utc(now()), 'DTSTART:' + utc(draw), 'SUMMARY:' + escapeText(title), 'DESCRIPTION:' + escapeText(description), 'TRANSP:TRANSPARENT', 'END:VEVENT', 'END:VCALENDAR'];
      calendarUrl = URL.createObjectURL(new Blob([lines.map(fold).join('\r\n') + '\r\n'], { type: 'text/calendar;charset=utf-8' }));
      calendar.href = calendarUrl;
      calendar.hidden = false;
      schedule.querySelector('[data-uca-calendar-note]').hidden = !validClose;
    }
  }
  schedule.hidden = !validClose && !validDraw;
  function tick() {
    clearTimeout(timer);
    if (document.visibilityState === 'hidden') return;
    if (validClose) {
      const left = Math.max(0, Math.ceil((closes - now()) / 1000));
      const values = [Math.floor(left / 86400), Math.floor(left % 86400 / 3600), Math.floor(left % 3600 / 60), left % 60];
      [...digits.querySelectorAll('[data-uca-clock-unit]')].forEach((node, i) => { node.textContent = String(values[i]).padStart(2, '0'); });
      if (left === 0) {
        digits.hidden = true;
        schedule.querySelector('[data-uca-entry-label]').textContent = label('closed');
      }
    }
    if (validDraw && draw <= now() && calendar) {
      calendar.hidden = true;
      schedule.querySelector('[data-uca-calendar-note]').hidden = true;
    }
    if ((validClose && closes > now()) || (validDraw && draw > now())) timer = setTimeout(tick, 1000);
  }
  document.addEventListener('visibilitychange', tick);
  window.addEventListener('pageshow', tick);
  window.addEventListener('pagehide', event => { clearTimeout(timer); if (!event.persisted && calendarUrl) URL.revokeObjectURL(calendarUrl); });
  tick();
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uppercut-header"]) return;
  try {
    
document.querySelectorAll('.uc-menu').forEach(menu => {
 menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => menu.removeAttribute('open')));
 menu.addEventListener('keydown', event => { if (event.key === 'Escape') { menu.removeAttribute('open'); menu.querySelector('summary').focus(); } });
 document.addEventListener('click', event => { if (!menu.contains(event.target)) menu.removeAttribute('open'); });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uppercut-premium"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = root => root.querySelectorAll('.uc-home').forEach(home => {
  if(home.dataset.ucReady) return;
  home.dataset.ucReady='true';
  const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const cleanups=[];
  const track=home.querySelector('.uc-winner-grid');
  const updateSlides=()=>{home.querySelectorAll('[data-uc-slide]').forEach(button=>{button.disabled=Number(button.dataset.ucSlide)<0?track.scrollLeft<5:track.scrollLeft+track.clientWidth>=track.scrollWidth-5;});};
  home.querySelectorAll('[data-uc-slide]').forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.ucSlide)*(track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:reduced?'instant':'smooth'})));
  track.addEventListener('scroll',updateSlides,{passive:true});window.addEventListener('resize',updateSlides);updateSlides();cleanups.push(()=>window.removeEventListener('resize',updateSlides));
  const gold=home.querySelector('.uc-tone-gold');
  const motionToggle=home.querySelector('.uc-motion-toggle');
  if(gold&&!reduced&&'IntersectionObserver' in window){
   motionToggle.hidden=false;
   motionToggle.addEventListener('click',()=>{
    const paused=home.classList.toggle('uc-motion-paused');
    motionToggle.setAttribute('aria-pressed',String(paused));
   });
   const goldObserver=new IntersectionObserver(entries=>entries.forEach(entry=>gold.classList.toggle('uc-gold-in-view',entry.isIntersecting)),{threshold:.15});
   goldObserver.observe(gold);cleanups.push(()=>goldObserver.disconnect());
  }

  const hero=home.querySelector('.uc-hero');
  const packages=home.querySelector('.uc-packages');
  const dock=home.querySelector('.uc-mobile-dock');
  if('IntersectionObserver' in window){
   if(!reduced){
    const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
     if(entry.isIntersecting){entry.target.classList.add('uc-is-visible');observer.unobserve(entry.target);}
    }),{threshold:.07,rootMargin:'0px 0px -20px 0px'});
    home.querySelectorAll('[data-uc-reveal]').forEach(el=>{
     const siblings=[...el.parentElement.children];
     const columns=window.innerWidth<750?2:3;
     el.style.setProperty('--uc-delay',el.classList.contains('uc-package')?`${(siblings.indexOf(el)%columns)*90}ms`:'0ms');
     el.classList.add('uc-reveal-ready');observer.observe(el);
    });
    cleanups.push(()=>observer.disconnect());
   }
   let heroVisible=true,packagesVisible=false;
   const dockObserver=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{if(entry.target===hero)heroVisible=entry.isIntersecting;else packagesVisible=entry.isIntersecting;});
    dock.classList.toggle('uc-dock-visible',!heroVisible&&!packagesVisible);
   });
   dockObserver.observe(hero);dockObserver.observe(packages);cleanups.push(()=>dockObserver.disconnect());
  }
  if(!reduced){
   const progress=document.createElement('div');progress.className='uc-scroll-progress';progress.setAttribute('aria-hidden','true');home.append(progress);
   const winners=[...home.querySelectorAll('.uc-winner')];let queued=false,frame;
   const paint=()=>{
    queued=false;
    const bounds=home.getBoundingClientRect(),heroBounds=hero.getBoundingClientRect(),height=window.innerHeight;
    home.style.setProperty('--uc-scroll',Math.max(0,Math.min(1,-heroBounds.top/heroBounds.height)).toFixed(3));
    home.style.setProperty('--uc-progress',Math.max(0,Math.min(1,-bounds.top/Math.max(1,bounds.height-height))).toFixed(3));
    winners.forEach(el=>{const rect=el.getBoundingClientRect();if(rect.top<height&&rect.bottom>0)el.style.setProperty('--uc-image-scale',(1+Math.max(0,Math.min(1,(height-rect.top)/(height+rect.height)))*.035).toFixed(3));});
   };
   const schedule=()=>{if(!queued){queued=true;frame=requestAnimationFrame(paint);}};
   window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule,{passive:true});paint();
   cleanups.push(()=>{window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule);cancelAnimationFrame(frame);});
  }
  const unload=event=>{if(event.target.contains(home)){cleanups.forEach(fn=>fn());document.removeEventListener('shopify:section:unload',unload);}};
  document.addEventListener('shopify:section:unload',unload);
 });
 init(document);document.addEventListener('shopify:section:load',event=>init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
